<script>
export default {
  name: "i-variant"
}
</script>

<template>
	<svg width="100%" height="100%" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M6.82862 0.827586C6.82862 0.370523 6.4581 0 6.00104 0C5.54397 0 5.17345 0.370523 5.17345 0.827586V5.17245H0.827586C0.370523 5.17245 0 5.54297 0 6.00004C0 6.4571 0.370523 6.82762 0.827586 6.82762H5.17345V11.1724C5.17345 11.6295 5.54397 12 6.00104 12C6.4581 12 6.82862 11.6295 6.82862 11.1724V6.82762H11.1724C11.6295 6.82762 12 6.4571 12 6.00004C12 5.54297 11.6295 5.17245 11.1724 5.17245H6.82862V0.827586Z" fill="currentColor"/>
	</svg>
</template>

<style scoped>

</style>
